import React from 'react';
import { useDispatch } from 'react-redux';

import { updateAddReplyId } from 'actions/comments';
import { COMMENTS_BREAKPOINT } from 'constants/breakpoints';
import { CREATION_METHOD_COMMENT_OVERLAY } from 'constants/comments';
import { ROLLOUT_AT_MENTION_COMMENT } from 'constants/featureFlag';

import useMedia from 'hooks/useMedia';
import { useFlagIsActivated } from 'hooks/featureFlag';

import CommentInputGroup from '../../../../comment-input-group';

const AddReply = React.forwardRef((props, ref) => {
  const { addReplyId } = props;
  const isMentionComponentEnabled = useFlagIsActivated({
    flag: ROLLOUT_AT_MENTION_COMMENT,
    activationValues: [true],
  });
  const dispatch = useDispatch();
  const closeAddReply = () => {
    dispatch(updateAddReplyId(null));
  };

  const placeholder = isMentionComponentEnabled
    ? 'Leave a reply or add others with @'
    : 'Leave a reply';

  const fullSize = useMedia(
    [`(min-width: ${COMMENTS_BREAKPOINT}px)`],
    [true],
    false
  );

  return (
    <div ref={ref}>
      <CommentInputGroup
        addReplyId={addReplyId}
        creationMethod={CREATION_METHOD_COMMENT_OVERLAY}
        drawCancel="true"
        grabFocus="true"
        hideNameIfPresent="true"
        inputSize={fullSize ? 'medium' : 'small'}
        onCancel={closeAddReply}
        onSubmit={closeAddReply}
        placeholder={placeholder}
        submitButtonText="Reply"
      ></CommentInputGroup>
    </div>
  );
});

export default AddReply;
